import React from "react";

export const tooltipInterventionRates = () => {
  return (
    <span>
      <b>Tarification des prestations</b>
      <br />
      <br />
      <b>En personne :</b> facturation par tranches de 15 minutes (16.50 CHF),
      avec un minimum facturé d'1 heure.
      <br />
      <br />
      <b>Téléphone & visioconférence :</b> facturation par tranches de 10
      minutes (17 CHF), avec un minimum facturé de 20 minutes.
    </span>
  );
};
